<template>
  <div
    :class="{'card-element': true, selected: goal === selectedCard}"
    role="button"
    tabindex="0"
    @click="selectOption"
    @keyup.enter="selectOption"
  >
    <p v-html="want"></p>
    <div class="title-container">
      <h3 v-html="action"></h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardElement",
  props: {
    goal: String,
    want: String,
    action: String
  },
  computed: {
    selectedCard() {
      return this.$store.state.mainGoal
    }
  },
  methods: {
    selectOption() {
      this.$store.commit("setStateValue", {
        stateKey: "mainGoal",
        incomingValue: this.goal
      })
      
    }
  }
}
</script>

<style lang="scss">
 .card-element {
  border: 3px solid $white;
  cursor: pointer;
  height: 289px;
  margin: 4.948vw;
  max-width: 289px;
  outline: none;
  padding: 60px 0 0 0;
  text-align: center;
  transition: background-color 0.3s, margin 0.3s;
  width: 100%;

  @media print, screen and (min-width: 48em) {
    margin: 38px;
  }
  
  &.selected {
    background: $primary_purple_3;
  }

  &:hover {
    background: $hover_purple;
  }

  &:focus-visible {
    background-color: $hover_purple;
    border-color: $secondary_green;
  }

  p {
    color: $white;
    font-size: 20px;
    line-height: 1.05;
    margin: 0 0 32px 0;

    span {
      font-weight: bold;
    }
  }

  .title-container {
    align-content: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 84px;

    h3 {
      font-size: 10vw;
      font-weight: 600;
      line-height: 1.05;
      margin: 0;

      @media print, screen and (min-width: 25em) {
        font-size: 40px;
      }
    }
  }
 }
</style>